// import PortfolioBanner from "../Sections/PortfolioBanner";
import PortfolioGrid from '../Sections/PortfolioGrid';
import BottomFooterPortfolio from "../Sections/bottomFooterPortfolio";
import WhatsappWidget from "../Components/Whatsapp Widget/WhatsappWidget";

function Portfolio() {
  return (
    <>
      {/* <PortfolioBanner /> */}
      <PortfolioGrid />
      <BottomFooterPortfolio />
      <WhatsappWidget />
    </>
  );
}

export default Portfolio;
